import React from 'react';
import { PriceBooksRegistrationEntryPoint } from '@thd-olt-component-react/ocm_pd_component_myaccount-pricebook';
import { PageSectionPB } from '../shared';
import { PrefPricingBanner, PrefPricingBlurbs } from './components';
import {
  determineMembershipLevel,
  getBenefitTag,
  MembershipLevel,
} from '../../Utils';
import { useRewardsAndOffers } from '../../../hooks';

export const PreferredPricing = ({
  isMobile,
}: {
  isMobile: boolean;
}): JSX.Element => {
  const { rewardsAndOffers, isRegistrationEntryPointEnabled } =
    useRewardsAndOffers();
  const membershipLevel: MembershipLevel =
    determineMembershipLevel(rewardsAndOffers);
  const isQualified =
    getBenefitTag(rewardsAndOffers, 'PreferredPricing')?.value === 'unlocked';
  const hasRegistrationNewPPTag = !!getBenefitTag(
    rewardsAndOffers,
    'Registration_New_PP',
  ).tag;
  const showRegistrationEntryPoint =
    isRegistrationEntryPointEnabled && hasRegistrationNewPPTag;

  return (
    <>
      <PageSectionPB
        title={showRegistrationEntryPoint ? null : 'Pro Xtra Preferred Pricing'}
        classes="sui-pt-4 sui-mt-2"
        isMobile={isMobile}
      >
        {showRegistrationEntryPoint ? (
          <PriceBooksRegistrationEntryPoint />
        ) : (
          <PrefPricingBanner isMobile={isMobile} isQualified={isQualified} />
        )}
        {(!showRegistrationEntryPoint || membershipLevel !== 'MEMBER') && (
          <PrefPricingBlurbs
            isMobile={isMobile}
            isQualified={isQualified}
            showRegistrationEntryPoint={showRegistrationEntryPoint}
          />
        )}
      </PageSectionPB>
      {showRegistrationEntryPoint && (
        <hr className="sui-border-solid sui-border-primary sui-border-0 sui-border-b-1 sui-mb-10" />
      )}
    </>
  );
};
